/**
 * 时区工具函数
 */

// 常用时区列表
export const TIMEZONE_LIST = [
  { value: 'Asia/Dubai', label: '迪拜时间 (UTC+4)', offset: 4 },
  { value: 'Asia/Shanghai', label: '中国标准时间 (UTC+8)', offset: 0 },
  { value: 'Asia/Kolkata', label: '印度标准时间 (UTC+5.5)', offset: 5.5 }
//   { value: 'Asia/Hong_Kong', label: '香港时间 (UTC+8)', offset: 0 },
//   { value: 'Asia/Taipei', label: '台北时间 (UTC+8)', offset: 0 },
//   { value: 'Asia/Singapore', label: '新加坡时间 (UTC+8)', offset: 0 },
//   { value: 'Asia/Tokyo', label: '日本标准时间 (UTC+9)', offset: 9 },
//   { value: 'Asia/Seoul', label: '韩国标准时间 (UTC+9)', offset: 9 },
//   { value: 'America/New_York', label: '美国东部时间 (UTC-5)', offset: -5 },
//   { value: 'America/Chicago', label: '美国中部时间 (UTC-6)', offset: -6 },
//   { value: 'America/Denver', label: '美国山地时间 (UTC-7)', offset: -7 },
//   { value: 'America/Los_Angeles', label: '美国太平洋时间 (UTC-8)', offset: -8 },
//   { value: 'Europe/London', label: '英国时间 (UTC+0)', offset: 0 },
//   { value: 'Europe/Paris', label: '欧洲中部时间 (UTC+1)', offset: 1 },
//   { value: 'Europe/Berlin', label: '德国时间 (UTC+1)', offset: 1 },
//   { value: 'Australia/Sydney', label: '澳大利亚东部时间 (UTC+10)', offset: 10 },
//   { value: 'Australia/Perth', label: '澳大利亚西部时间 (UTC+8)', offset: 8 },
//   { value: 'UTC', label: '协调世界时 (UTC+0)', offset: 0 }
]

/**
 * 获取当前时区
 * @returns {string} 当前时区
 */
export function getCurrentTimezone () {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/**
 * 获取时区偏移量（小时）
 * @param {string} timezone 时区名称
 * @returns {number} 偏移量（小时）
 */
export function getTimezoneOffset (timezone) {
  const date = new Date()
  const utc = date.getTime() + (date.getTimezoneOffset() * 60000)
  const targetTime = new Date(utc + (TIMEZONE_LIST.find(tz => tz.value === timezone)?.offset || 0) * 3600000)
  return targetTime.getTimezoneOffset() / -60
}

/**
 * 格式化时区显示名称
 * @param {string} timezone 时区名称
 * @returns {string} 格式化的时区名称
 */
export function formatTimezoneLabel (timezone) {
  const tzInfo = TIMEZONE_LIST.find(tz => tz.value === timezone)
  if (tzInfo) {
    return tzInfo.label
  }
  return timezone
}

/**
 * 获取时区选项列表
 * @returns {Array} 时区选项列表
 */
export function getTimezoneOptions () {
  return TIMEZONE_LIST
}

/**
 * 根据时区转换时间
 * @param {Date|string} date 日期
 * @param {string} targetTimezone 目标时区
 * @returns {Date} 转换后的日期
 */
export function convertToTimezone (date, targetTimezone) {
  const d = new Date(date)
  const utc = d.getTime() + (d.getTimezoneOffset() * 60000)
  const targetOffset = TIMEZONE_LIST.find(tz => tz.value === targetTimezone)?.offset || 0
  return new Date(utc + (targetOffset * 3600000))
}

/**
 * 格式化时间为指定时区
 * @param {Date|string} date 日期
 * @param {string} timezone 时区
 * @param {string} format 格式
 * @returns {string} 格式化后的时间字符串
 */
export function formatInTimezone (date, timezone, format = 'YYYY-MM-DD HH:mm:ss') {
  const convertedDate = convertToTimezone(date, timezone)

  const year = convertedDate.getFullYear()
  const month = String(convertedDate.getMonth() + 1).padStart(2, '0')
  const day = String(convertedDate.getDate()).padStart(2, '0')
  const hours = String(convertedDate.getHours()).padStart(2, '0')
  const minutes = String(convertedDate.getMinutes()).padStart(2, '0')
  const seconds = String(convertedDate.getSeconds()).padStart(2, '0')

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}
